import React from 'react'
import Header from '../Layout/Sign/Header'
import Main from '../Layout/Sign/Main'
import Footer from '../Layout/Sign/Footer'

function SignScreen() {

    return (

        <>
        
            <Header/>

            <Main/>

            <Footer/>

        </>

    )

}

export default SignScreen